import SimpleLightbox from "simplelightbox";

class CustomPhotoSwipeLightbox {
    constructor() {
        this.init();
    }

    init() {
        const lightbox = new SimpleLightbox('.js-product-lightbox .gallery--item', {});
    }
}

new CustomPhotoSwipeLightbox();
